const GOOGLE_MAPS_API_KEY = "AIzaSyBiR19qrpiPi5MSm-0xFbWn5boPcuEbmys";
export { GOOGLE_MAPS_API_KEY };
